<template>
    <div class="society safe-distance-top">
        <div class="society_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">社会任职</div>
            <div class="determine" @click="determine">提交</div>
        </div>
        <div class="society_bottom">
            <van-field
                v-model="society"
                rows="2"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入个人社会任职"
                show-word-limit
                ref="input"
            />
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "society",
    data() {
        return {
            society: "",
            // 社会任职
            societyId: "",
        };
    },
    created() {
        this.societyId = this.$route.query.societyId;
    },

    mounted() {
        // 回显
        this.society = JSON.parse(sessionStorage.getItem("societycontent"));
        // 聚焦
        this.$nextTick(() => {
            this.$refs.input.focus();
        });
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        determine() {
            if (this.society == "") {
                Toast("不能为空");
            } else {
                this.addOrEditExperience();
                window.history.go(-1);
            }
        },
        // 保存提交
        async addOrEditExperience() {
            let res = await this.$apis.userServe.addOrEditExperience({
                content: this.society,
                id: this.societyId,
                type: 8,
            });
            if (res.data.resultCode == 200) {
                Toast("提交成功");
            } else {
                Toast(res.data.resultDesc);
            }
            console.log("是否成功?", res);
        },
    },
};
</script>

<style lang="scss" scoped>
.society {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .society_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .society_bottom {
        width: 94%;
        margin: 12px auto;
        border-radius: 8px;

        .van-field {
            border-radius: 8px;
        }
    }
}
</style>
